import React from "react";
import styled from "styled-components";
import { FaRocket, FaChartLine, FaMoneyBillWave } from "react-icons/fa";
import colors from "../colors";
import { useEffect, useRef, useState } from "react";

const HeroContainer = styled.div`
  background-color: ${colors.darkPurple};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: 800px;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 768px) {
    height: auto;
    padding: 100px 0;
  }
`;

const HeroBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const StarsBg = styled.div`
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(26, 11, 46, 0.8) 0%,
    rgba(26, 11, 46, 1) 100%
  );
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: radial-gradient(
      white,
      rgba(255, 255, 255, 0.2) 2px,
      transparent 2px
    );
    background-size: 50px 50px;
    opacity: 0.2;
  }
`;

const HeroContent = styled.div`
  z-index: 3;
  max-width: 1200px;
  position: relative;
  padding: 8px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 0 24px;
  }
`;

const HeroTextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    padding-bottom: 30px;
    text-align: center;
  }
`;

const TopLine = styled.p`
  color: ${colors.lightPurple};
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: #fff;

  span {
    background: ${colors.gradientPrimary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media screen and (max-width: 768px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
`;

const HeroBtnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    display:none
  }
`;

const HeroBtnWrapper2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;

  @media screen and (min-width: 769px) {
    display: none;
  }
`;

const Button = styled.a`
  border-radius: 50px;
  background: ${(props) =>
    props.primary ? colors.gradientButton : "transparent"};
  white-space: nowrap;
  padding: ${(props) => (props.big ? "14px 48px" : "12px 30px")};
  color: ${(props) => (props.dark ? colors.darkPurple : "#fff")};
  font-size: ${(props) => (props.fontBig ? "20px" : "16px")};
  outline: none;
  border: ${(props) =>
    props.primary ? "none" : `1px solid ${colors.lightPurple}`};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  margin-right: ${(props) => (props.primary ? "20px" : "0")};
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${(props) => (props.primary ? "#fff" : colors.lightPurple)};
    color: ${(props) => (props.primary ? colors.purple : "#fff")};
  }

  @media screen and (max-width: 768px) {
    margin-right: 0;
    margin-bottom: ${(props) => (props.primary ? "20px" : "0")};
    width: 100%;
  }
`;

const HeroImgWrapper = styled.div`
  max-width: 555px;
  height: 100%;

  @media screen and (max-width: 768px) {
    max-width: 80%;
    height: 60vh;
  }
`;

const HeroImg = styled.div`
  width: 100%;
  // margin: 0 0 50px -50px;
  margin: 0 0 156px 0px;
  padding-right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  // background: ${colors.gradientPrimary};
  border-radius: 10px;
  position: relative;
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.2);
    // background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M50 50 L80 80 L20 80 Z' fill='%23ffffff' fill-opacity='0.2'/%3E%3C/svg%3E");
    background-size: 50px 50px;
  }
  img {
    height: 504px;
  }

  /* Esconder barra de scroll para Webkit (Chrome, Safari, Edge) */
  #chat-window::-webkit-scrollbar {
    display: none;
  }
  
  /* Esconder barra de scroll para Firefox */
  #chat-window {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
`;

const IconPlaceholder = styled.div`
  font-size: 80px;
  color: rgba(255, 255, 255, 0.8);
  z-index: 2;
`;

const StatsSection = styled.section`
  padding: 100px 0;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StatsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const StatCard = styled.div`
  width: 250px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  margin: 0 10px;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  @media screen and (max-width: 768px) {
    margin: 10px 0;
    width: 90%;
  }
`;

const StatIcon = styled.div`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  color: ${(props) => props.color};
`;

const StatH1 = styled.h1`
  font-size: 2.5rem;
  color: ${colors.purple};
  margin-bottom: 10px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const StatH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 10px;
`;

const Hero = () => {
  const statsData = [
    {
      id: 1,
      target: 60,
      label: "Redução no tempo médio de resposta",
      icon: <FaRocket />,
      color: colors.purple,
    },
    {
      id: 2,
      target: 25,
      label: "Aumento no ticket médio",
      icon: <FaChartLine />,
      color: colors.lightPink,
    },
    {
      id: 3,
      target: 18,
      label: "Crescimento nas vendas mensal",
      icon: <FaMoneyBillWave />,
      color: colors.skyBlue,
    },
  ];

  const [counts, setCounts] = useState(statsData.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  // Chat functionality
  const messagesRef = useRef(null);
  const typingRef = useRef(null);
  const currentIndexRef = useRef(0);
  const chatStartedRef = useRef(false);
  const [messageCount, setMessageCount] = useState(0);

  const messages = [
    { text: "Oi! Você tem base para pele oleosa?", from: "user" },
    { text: "Olá! 😊 Tenho sim! Temos bases ideais para pele oleosa das marcas Ruby Rose, Vult e Maybelline.", from: "bot" },
    { text: "A da Maybelline está quanto?", from: "user" },
    { text: "A Base Fit Me da Maybelline está por R$ 49,90.", from: "bot" },
    { text: "Tem na cor média?", from: "user" },
    { text: "Sim, temos disponível! Quer que eu reserve ou te mando o link para comprar agora mesmo?", from: "bot" },
    { text: "Me manda o link!", from: "user" },
    { text: "Claro! Aqui está 👉 <a href='#' style='color: #34B7F1;'>link fictício</a><br>Frete grátis nas compras acima de R$ 100. Posso te ajudar com mais algum item de maquiagem?", from: "bot" }
  ];

  const scrollToBottom = () => {
    const chatWindow = document.getElementById("chat-window");
    if (chatWindow) {
      chatWindow.scrollTop = chatWindow.scrollHeight;
    }
  };

  // useEffect para fazer scroll sempre que uma nova mensagem for adicionada
  useEffect(() => {
    if (messageCount > 0) {
      const timer = setTimeout(() => {
        scrollToBottom();
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [messageCount]);

  const addMessage = (msg, from) => {
    if (messagesRef.current) {
      const msgDiv = document.createElement("div");
      msgDiv.style.maxWidth = "60%";
      msgDiv.style.maxHeight = "25%";
      msgDiv.style.padding = "10px";
      msgDiv.style.borderRadius = "10px";
      msgDiv.style.wordBreak = "break-word";
      msgDiv.style.lineHeight = "1.3";

      if (from === "user") {
        msgDiv.style.background = "#dcf8c6";
        msgDiv.style.alignSelf = "flex-end";
      } else {
        msgDiv.style.background = "#fff";
        msgDiv.style.alignSelf = "flex-start";
      }

      msgDiv.innerHTML = msg;
      messagesRef.current.appendChild(msgDiv);
      
      // Incrementa o contador para triggerar o useEffect
      setMessageCount(prev => prev + 1);
    }
  };

  const showNextMessage = () => {
    if (currentIndexRef.current < messages.length) {
      const { text, from } = messages[currentIndexRef.current];
      const typing = typingRef.current;

      if (from === "bot") {
        if (typing) typing.style.display = "block";
        scrollToBottom();
      } else {
        if (typing) typing.style.display = "none";
      }

      setTimeout(() => {
        if (typing) typing.style.display = "none";
        addMessage(text, from);
        currentIndexRef.current++;
        showNextMessage();
      }, currentIndexRef.current === 0 ? 500 : (from === "bot" ? 4000 : 3000));
    } else {
      // Chat terminou, reiniciar após 7 segundos
      setTimeout(() => {
        // Limpar mensagens
        if (messagesRef.current) {
          messagesRef.current.innerHTML = '';
        }
        // Resetar contadores
        currentIndexRef.current = 0;
        setMessageCount(0);
        // Reiniciar o chat
        showNextMessage();
      }, 7000);
    }
  };

  useEffect(() => {
    // Start chat after component mounts (only once)
    if (!chatStartedRef.current) {
      chatStartedRef.current = true;
      setTimeout(showNextMessage, 1000);
    }
  }, []);

  // Função de contagem (a mesma que você já tinha)
  const startCounting = () => {
    const duration = 8000;
    const maxTarget = Math.max(...statsData.map((stat) => stat.target));
    const stepTime = Math.max(Math.floor(duration / maxTarget), 80);

    const interval = setInterval(() => {
      setCounts((prevCounts) =>
        prevCounts.map((count, i) =>
          count < statsData[i].target ? count + 1 : count
        )
      );
    }, stepTime);

    setTimeout(() => clearInterval(interval), duration + 800);
  };

  // Iniciar quando scroll mostrar o componente
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          startCounting();
          setHasAnimated(true);
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);

  return (
    <>
      <HeroContainer id="home">
        <HeroBg>
          <StarsBg />
        </HeroBg>
        <HeroContent>
          <HeroTextWrapper>
            <TopLine>Especialista em Vendas</TopLine>
            <Heading>
              <span>Automatize</span> suas vendas com funcionários de IA que
              trabalham por você
            </Heading>
            <Subtitle>
              Contrate Funcionários de Inteligência Artificial prontos para
              escalar vendas. Sem pausa. Sem férias. Sem erros. Sem desculpas
              24/7.
            </Subtitle>
            <HeroBtnWrapper>
              <Button
                href="https://wa.me/551152868938?text=Olá%2C%20gostaria%20de%20mais%20informações"
                target="_blank"
                primary
                big
                fontBig
              >
                Começar agora
              </Button>
              <Button href="/#planos" big fontBig>
                <span>Ver planos </span>
                <FaRocket />
              </Button>
            </HeroBtnWrapper>
          </HeroTextWrapper>
          <HeroImgWrapper>
            <HeroImg>
              <div id="whatsapp-chat" style={{
                maxWidth: '350px', 
                margin: 'auto', 
                fontFamily: 'sans-serif', 
                backgroundColor: '#e5ddd5', 
                padding: '15px', 
                borderRadius: '10px', 
                boxShadow: '0 0 10px #4CAF50'
              }}>
                <div id="chat-window" style={{
                  background: '#fff', 
                  borderRadius: '10px', 
                  padding: '10px', 
                  maxHeight: '300px', 
                  position: 'relative', 
                  overflowY: 'auto'
                }}>
                  <div 
                    ref={messagesRef}
                    id="messages" 
                    style={{
                      display: 'flex', 
                      flexDirection: 'column', 
                      gap: '10px'
                    }}
                  />
                  <div 
                    ref={typingRef}
                    id="typing" 
                    style={{
                      display: 'none',
                      fontSize: '0.9em', 
                      color: '#999', 
                      marginTop: '10px'
                    }}
                  >
                    iadevenda está digitando...
                  </div>
                </div>
              </div>
            </HeroImg>
          </HeroImgWrapper>
          <HeroBtnWrapper2>
            <Button
              href="https://wa.me/551152868938?text=Olá%2C%20gostaria%20de%20mais%20informações"
              target="_blank"
              primary
              big
              fontBig
            >
              Começar agora
            </Button>
            <Button href="/#planos" big fontBig>
              <span>Ver planos </span>
              <FaRocket />
            </Button>
          </HeroBtnWrapper2>
        </HeroContent>
      </HeroContainer>

      <StatsSection id="stats">
        <StatH1>Vendas inteligentes, resultados reais!</StatH1>
        <StatsContainer ref={sectionRef}>
          {statsData.map((stat, index) => (
            <StatCard
              key={stat.id}
              className="counter"
              data-target={stat.target}
            >
              <StatIcon color={stat.color}>{stat.icon}</StatIcon>
              <StatH1>
                <span className="counter-number">+{counts[index]}%</span>
              </StatH1>
              <StatH2>{stat.label}</StatH2>
            </StatCard>
          ))}
        </StatsContainer>
      </StatsSection>
    </>
  );
};

export default Hero;
